import { render } from "./LiquorLicense.vue?vue&type=template&id=66c0c29e&scoped=true"
import script from "./LiquorLicense.vue?vue&type=script&lang=js"
export * from "./LiquorLicense.vue?vue&type=script&lang=js"

import "./LiquorLicense.vue?vue&type=style&index=0&id=66c0c29e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c0c29e"]])

export default __exports__